import type { RollingBannerListProps } from './types';
import { RollingBanner } from './RollingBanner';
import { SlideQueueBanner } from './SlideQueueBanner';

/**
 * view_type 에 따라 두 구현으로 분기:
 * - 'SLIDE_QUEUE' → parallax carousel (SlideQueueBanner)
 * - 그 외 (null)  → 무한 스크롤 rolling (RollingBanner)
 *
 * 공유 로깅은 useLogClickBanner / useLogDisplayBanner 로 추출되어 있다.
 */
export const RollingBannerList = (props: RollingBannerListProps) => {
  if (props.body.item.view_type === 'SLIDE_QUEUE' && props.entity.length > 1) {
    return <SlideQueueBanner {...props} />;
  }
  return <RollingBanner {...props} />;
};
